<template>
  <div class='theme-multiple-files__holder'>
    <h3 class="mb-2">{{ hint }}</h3>
    <label :for='id' class='theme-multiple-files'>
      <span class='theme-btn theme-btn--theme theme-btn--small theme-multiple-files__desktop-btn w-full mb-2' :class="{'theme-multiple-files__desktop-btn--white': white}">
        <i class='icon-upload' style='font-size: 20px;'/>
        <span class='theme-multiple-files__button-text'>
          {{ locales && locales.common && locales.common.choose_file }}
        </span>
      </span>
    </label>

    <div>
      <div v-if="Object.keys(files).length > 0" class="flex gap-2 flex-wrap">
        <span v-for="file in files" class='theme-multiple-files-text'>
          {{ file.name }}
        </span>
      </div>
      <span v-else class='theme-multiple-files-text'>{{ locales && locales.common && locales.common.no_file_chosen }}</span>
    </div>
      
    <input
      style='display: none;'
      :class='inputClass'
      type='file'
      :accept='accept'
      :name="name"
      :id='id'
      @change='change'
      :ref="id"
      multiple
    />
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  export default {
    props: {
      name: {
        default: 'file',
        type: String,
      },
      accept: {
        default: '',
        type: String,
      },
      id: {
        default: '',
        type: String,
      },
      inputClass: {
        default: '',
        type: String,
      },
      white: {
        default: false,
        type: Boolean,
      },
      hint: {
        default: 'Hint: Hold the CTRL key while selecting multiple images at once.',
        type: String,
      },
    },
    data() {
      return {
        files: {},
      };
    },
    computed: {
      ...mapGetters(['locales']),
    },
    methods: {
      change: function(event) {
        this.$emit('change', event);
        if (event.target.files && event.target.files.length > 0) {
          this.files = event.target.files;
        } else {
          this.files = {};
        }
      },
      clearInput: function () {
        this.fileName = '';
        this.$refs[this.id].value = '';
      }
    },
    created() {
      this.$root.$on("uploading-completed", () => {
        this.files = {};
      });
    },
  };
</script>


// WEBPACK FOOTER //
// resources/js/components/ThemeMultipleFiles.vue